import { useEffect, useState } from 'react';
import { gridRowHeightForSection } from './designKit';
import { GRID_ROW_HEIGHT } from './defaults';

/** Largeur de maquette desktop Jardins — proportions stables entre écrans PC. */
export const JARDINS_DESKTOP_REF_WIDTH = 1440;

export function resolveJardinsFluidScale(layoutWidth, viewport = 'desktop') {
  if (viewport !== 'desktop') return 1;
  const w = Math.max(320, Number(layoutWidth) || JARDINS_DESKTOP_REF_WIDTH);
  const raw = w / JARDINS_DESKTOP_REF_WIDTH;
  return Math.min(1.12, Math.max(0.8, raw));
}

export function resolveJardinsFluidKitRowHeight(section, layoutWidth, viewport = 'desktop') {
  const base = gridRowHeightForSection(section) || GRID_ROW_HEIGHT;
  return base * resolveJardinsFluidScale(layoutWidth, viewport);
}

export function useJardinsLayoutWidth(active) {
  const [width, setWidth] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth : JARDINS_DESKTOP_REF_WIDTH,
  );

  useEffect(() => {
    if (!active) return undefined;
    const update = () => setWidth(window.innerWidth);
    update();
    window.addEventListener('resize', update, { passive: true });
    return () => window.removeEventListener('resize', update);
  }, [active]);

  return width;
}

/** Largeur réelle du canvas (éditeur / aperçu), pas la fenêtre — pour le scale Jardins. */
export function useElementLayoutWidth(elementRef, active) {
  const [width, setWidth] = useState(JARDINS_DESKTOP_REF_WIDTH);

  useEffect(() => {
    if (!active) return undefined;
    const el = elementRef?.current;
    if (!el) return undefined;

    const measure = () => {
      const w = el.getBoundingClientRect().width;
      if (w > 0) setWidth(w);
    };

    measure();
    const ro = new ResizeObserver(() => measure());
    ro.observe(el);
    return () => ro.disconnect();
  }, [active, elementRef]);

  return width;
}

export function isJardinsHeroViewportFill(section, viewport, designKit = 'jardins') {
  return (
    viewport === 'desktop' &&
    section?.designKit === designKit &&
    section?.kitSectionTone === 'hero-dark'
  );
}
